import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { Eye, EyeOff } from "lucide-react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import logoPaseo from "../../../assets/imagenes/splash.png";
import grafismoPaseo from "../../../assets/imagenes/grafismo-paseo2.png";
import { getDetalleSorteo, postBuscarCuponSorteo } from "../../../api/ApiService";


function BuscarCuponPage() {
    const [cargando, setCargando] = useState(false);
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [loadingBuscar, setLoadingBuscar] = useState(false);
    const [numeroCupon, setNumeroCupon] = useState("");
    const [detalleSorteo, setDetalleSorteo] = useState(null);
    const [detalleCupon, setDetalleCupon] = useState(null);
    const [mostrarFactura, setMostrarFactura] = useState(false);

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');



    const stateToken = useSelector(state => state.reducerGlobal.token);
    const location = useLocation();

    const params = useParams();

    const { id } = params;


    const navigate = useNavigate();




    //==========================================================funcion para enviar encuesta a la api
    const handleDetalleSorteo = () => {
        getDetalleSorteo(id, stateToken?.access_token)
            .then(response => {
                console.log("getDetalleEvento", response);
                setCargando(true);

                setDetalleSorteo(response?.data);

            })
            .catch(error => {
                console.log("error-getDetalleEvento", error);
                setCargando(false);
                setDetalleSorteo(null);

                setMensaje("Error al cargar los datos");
                setSeverity('error');
                setOpen(true);
            })
    }

    useEffect(() => {
        if (id) {
            if (stateToken) {
                handleDetalleSorteo();
            }
        } else {
            setTimeout(() => {
                setCargando(true);
            }, 1000);
        }
    }, [id, stateToken]);





    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    const handleBuscarCupon = () => {
        if (!numeroCupon.trim()) {
            setSeverity('warning');
            setMensaje('Ingrese el número del cupón para continuar.');
            setOpen(true);
            return;
        }

        const body = {
            nro_cupon: numeroCupon.trim(),
            tipo_sorteo: "real",
            sorteo_especial: false

        };

        setLoadingBuscar(true);
        setDetalleCupon(null);
        setMostrarFactura(false);

        postBuscarCuponSorteo(stateToken?.access_token, id, body)
            .then(response => {
                console.log("postBuscarCuponSorteo", response);
                setDetalleCupon(response?.data || response);
                setLoadingBuscar(false);
            })
            .catch(error => {
                console.log("error-postBuscarCuponSorteo", error);
                setLoadingBuscar(false);
                setSeverity('error');
                setMensaje(error?.message || 'No se encontró el cupón.');
                setOpen(true);
            });
    };

    const handleBuscarOtroCupon = () => {
        setDetalleCupon(null);
        setNumeroCupon("");
        setMostrarFactura(false);
    };



    const handleVerFactura = () => {
        navigate(`/app/admin/sorteo/factura-cupon/${detalleCupon?.factura_id}?cupon=${detalleCupon?.numero_cupon || numeroCupon}`);
    };







    return (
        <HeaderCustom>
            <div className="min-h-screen bg-[#c9ced7] p-4 sm:p-6 md:p-10">
                <div className="mx-auto max-w-3xl">

                    {cargando ? (
                        <div>
                            {detalleCupon ? (
                                // ─── CARD resultado (diseño de la captura) ─── 
                                <div className="mb-10 w-full max-w-[480px] justify-center mx-auto">
                                    <div className="">
                                        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-[0_8px_30px_rgba(15,23,42,0.10)]">

                                            {/* Banner superior */}
                                            <img
                                                src={grafismoPaseo}
                                                alt="banner"
                                                className="h-[14px] w-full object-cover object-center"
                                            />

                                            <div className="px-8 pb-8 pt-6 text-center">
                                                {/* Nombre */}
                                                <h2 className="text-3xl font-bold text-[#194e7a]">
                                                    {detalleCupon?.ganador || detalleCupon?.nombre || "—"}
                                                </h2>

                                                {/* Número de cupón */}
                                                <p className="mt-1 text-base font-semibold text-[#194e7a]">
                                                    Nº Cupón {detalleCupon?.numero_cupon || numeroCupon}
                                                </p>

                                                {/* Separador */}
                                                <div className="my-5 border-t border-gray-100" />

                                                {/* Datos */}
                                                <div className="space-y-3 text-left">
                                                    <div className="flex items-center justify-between border-b border-gray-100 pb-3">
                                                        <span className="text-sm font-semibold text-gray-600">CI:</span>
                                                        <span className="text-sm font-medium text-[#194e7a]">
                                                            {detalleCupon?.ci || detalleCupon?.documento || "—"}
                                                        </span>
                                                    </div>

                                                    <div className="flex items-center justify-between border-b border-gray-100 pb-3">
                                                        <span className="text-sm font-semibold text-gray-600">Teléfono:</span>
                                                        <span className="text-sm font-medium text-[#194e7a]">
                                                            {detalleCupon?.numero_telefono || detalleCupon?.celular || "—"}
                                                        </span>
                                                    </div>

                                                    <div className="flex items-center justify-between border-b border-gray-100 pb-3">
                                                        <span className="text-sm font-semibold text-gray-600">Email:</span>
                                                        <span className="text-sm font-medium text-[#194e7a] break-all">
                                                            {detalleCupon?.email || detalleCupon?.correo || "—"}
                                                        </span>
                                                    </div>

                                                    <div className="flex items-center justify-between pb-1">
                                                        <span className="text-sm font-semibold text-gray-600">Factura:</span>
                                                        <div className="flex items-center gap-2">
                                                            {mostrarFactura && (
                                                                <span className="text-sm font-medium text-[#194e7a]">
                                                                    {detalleCupon?.factura || detalleCupon?.nro_factura || "—"}
                                                                </span>
                                                            )}
                                                            <button
                                                                type="button"
                                                                // onClick={() => setMostrarFactura(prev => !prev)}
                                                                onClick={handleVerFactura}
                                                                className="rounded-lg border border-gray-200 bg-gray-50 p-2 text-gray-500 transition hover:bg-gray-100"
                                                            >
                                                                {mostrarFactura ? <EyeOff size={16} /> : <Eye size={16} />}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Botón buscar otro */}
                                                <button
                                                    type="button"
                                                    onClick={handleBuscarOtroCupon}
                                                    className="mt-8 h-12 w-full rounded-full bg-[#0d4a73] text-base font-semibold text-white transition hover:bg-[#0b4063]"
                                                >
                                                    Buscar otro cupón
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="overflow-hidden bg-white shadow-[0_20px_50px_rgba(15,23,42,0.12)]">
                                    <div className="mx-auto flex min-h-[690px] max-w-[800px] flex-col items-center px-6 pb-0 pt-12 text-center sm:px-10">
                                        <img
                                            src={logoPaseo}
                                            alt="Paseo La Galeria"
                                            className="mb-12 w-[170px] object-contain sm:w-[190px]"
                                        />

                                        <div className="space-y-1">
                                            <h1 className="text-4xl font-bold tracking-[-0.03em] text-[#3f4047] sm:text-5xl">
                                                {detalleSorteo?.titulo || "N/A"}
                                            </h1>
                                            <p className="text-xl font-semibold text-[#3f4047] sm:text-[1.25rem]">
                                                Cupones Generados: {detalleSorteo?.cuponesGenerados ?? 0}
                                            </p>
                                        </div>

                                        {/* ─── FORMULARIO de búsqueda ─── */}
                                        {!detalleCupon && (
                                            <div className="mt-14 w-full max-w-[420px]">
                                                <label
                                                    htmlFor="numero_cupon"
                                                    className="mb-8 block text-[2rem] font-bold leading-none tracking-[-0.03em] text-[#194e7a] sm:text-[1.45rem]"
                                                >
                                                    Ingrese el Número del Cupón
                                                </label>

                                                <input
                                                    id="numero_cupon"
                                                    type="text"
                                                    value={numeroCupon}
                                                    onChange={(event) => setNumeroCupon(event.target.value)}
                                                    onKeyDown={(e) => e.key === 'Enter' && handleBuscarCupon()}
                                                    className="h-14 w-full rounded-2xl border border-[#cdd5df] bg-white px-5 text-center text-lg text-[#3f4047] outline-none transition focus:border-[#194e7a] focus:ring-4 focus:ring-[#194e7a]/10"
                                                />

                                                <button
                                                    type="button"
                                                    onClick={handleBuscarCupon}
                                                    disabled={loadingBuscar}
                                                    className="mt-12 h-14 w-full rounded-2xl bg-[#0d4a73] text-2xl font-semibold text-white mb-6 transition hover:bg-[#0b4063] disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                                                >
                                                    {loadingBuscar && <CircularProgress color="inherit" size={22} />}
                                                    {loadingBuscar ? "Buscando..." : "Buscar"}
                                                </button>
                                            </div>
                                        )}

                                        {/* ─── CARD resultado (diseño de la captura) ─── */}
                                        {detalleCupon && (
                                            <div className="mt-10 w-full max-w-[480px] mb-10">
                                                <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-[0_8px_30px_rgba(15,23,42,0.10)]">

                                                    {/* Banner superior */}
                                                    <img
                                                        src={grafismoPaseo}
                                                        alt="banner"
                                                        className="h-[14px] w-full object-cover object-center"
                                                    />

                                                    <div className="px-8 pb-8 pt-6 text-center">
                                                        {/* Nombre */}
                                                        <h2 className="text-3xl font-bold text-[#194e7a]">
                                                            {detalleCupon?.nombre_completo || detalleCupon?.nombre || "—"}
                                                        </h2>

                                                        {/* Número de cupón */}
                                                        <p className="mt-1 text-base font-semibold text-[#194e7a]">
                                                            Nº Cupón {detalleCupon?.numero_cupon || numeroCupon}
                                                        </p>

                                                        {/* Separador */}
                                                        <div className="my-5 border-t border-gray-100" />

                                                        {/* Datos */}
                                                        <div className="space-y-3 text-left">
                                                            <div className="flex items-center justify-between border-b border-gray-100 pb-3">
                                                                <span className="text-sm font-semibold text-gray-600">CI:</span>
                                                                <span className="text-sm font-medium text-[#194e7a]">
                                                                    {detalleCupon?.ci || detalleCupon?.documento || "—"}
                                                                </span>
                                                            </div>

                                                            <div className="flex items-center justify-between border-b border-gray-100 pb-3">
                                                                <span className="text-sm font-semibold text-gray-600">Teléfono:</span>
                                                                <span className="text-sm font-medium text-[#194e7a]">
                                                                    {detalleCupon?.telefono || detalleCupon?.celular || "—"}
                                                                </span>
                                                            </div>

                                                            <div className="flex items-center justify-between border-b border-gray-100 pb-3">
                                                                <span className="text-sm font-semibold text-gray-600">Email:</span>
                                                                <span className="text-sm font-medium text-[#194e7a] break-all">
                                                                    {detalleCupon?.email || detalleCupon?.correo || "—"}
                                                                </span>
                                                            </div>

                                                            <div className="flex items-center justify-between pb-1">
                                                                <span className="text-sm font-semibold text-gray-600">Factura:</span>
                                                                <div className="flex items-center gap-2">
                                                                    {mostrarFactura && (
                                                                        <span className="text-sm font-medium text-[#194e7a]">
                                                                            {detalleCupon?.factura || detalleCupon?.nro_factura || "—"}
                                                                        </span>
                                                                    )}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => setMostrarFactura(prev => !prev)}
                                                                        className="rounded-lg border border-gray-200 bg-gray-50 p-2 text-gray-500 transition hover:bg-gray-100"
                                                                    >
                                                                        {mostrarFactura ? <EyeOff size={16} /> : <Eye size={16} />}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Botón buscar otro */}
                                                        <button
                                                            type="button"
                                                            onClick={handleBuscarOtroCupon}
                                                            className="mt-8 h-12 w-full rounded-full bg-[#0d4a73] text-base font-semibold text-white transition hover:bg-[#0b4063]"
                                                        >
                                                            Buscar otro cupón
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="mt-auto w-[calc(100%+3rem)] sm:w-[calc(100%+5rem)] ">
                                            <img
                                                src={grafismoPaseo}
                                                alt="Grafismo Paseo"
                                                className="h-[66px] w-full object-cover object-center"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) :
                        (
                            <div className="bg-white rounded-xl shadow-md p-8">
                                <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                                <div className="space-y-4">
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-24 bg-gray-200 rounded animate-pulse" />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default BuscarCuponPage;